import axios from 'axios';
import getConfig from 'next/config';
import persistor from 'utils/persistor';
import { asyncRetryReturnThrown } from 'utils/async';

const { publicRuntimeConfig } = getConfig();
const request = axios.create({
    baseURL: publicRuntimeConfig.apiUrl,
    validateStatus: (status) => (status >= 200 && status < 300) || status === 404,
});

request.interceptors.request.use(async config => {
    const { token } = persistor.getTokens();
    if (token) config.headers.Authorization = `Bearer ${token}`; // eslint-disable-line no-param-reassign
    return config;
});

export async function submitOrder(order) {
    const { data } = await request({
        url: '/user/orders',
        method: 'post',
        data: order,
    });

    return data.order;
}

export async function getOrder({ orderId, bookingEventId }) {
    const { data, status } = await asyncRetryReturnThrown(2, 5000, async () => {
        const result = await request({
            url: `/user/orders/${orderId}?${ bookingEventId ? `bookingEventId=${bookingEventId}` : '' }`,
            method: 'get',
        });
        if (result.status === 404) throw result;
        return result;
    });

    if (status === 404 && data.code === 'OrderNotFound') return;

    return data.order;
}

export async function getOrders() {
    const { data } = await request('/user/orders');

    return data.orders;
}

export async function updateOrder(orderId, orderData) {
    const { data } = await request({
        url: `/user/orders/${orderId}`,
        method: 'put',
        data: orderData.order,
    });

    return data.order;
}

export async function patchOrder(orderId, orderData) {
    const { data } = await request({
        url: `/user/orders/${orderId}`,
        method: 'patch',
        data: orderData,
    });
    return data.order;
}

export async function deleteOrder(orderId) {
    const { data } = await request({
        url: `/user/orders/${orderId}`,
        method: 'delete',
    });
    return data.order;
}
